import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../../context/AuthContext";
import { Controller, useForm } from "react-hook-form";
import { isEmpty, pick } from "lodash";
import { apiPost } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
import { toast } from "react-toastify";
import { Form } from "react-bootstrap";
import { preventMaxInput } from "../../Utils/constants";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { t } from "i18next";
const Affiliate = ({ setShow }) => {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [showPassword, setShowPassword] = useState([]);
  const inputRef = useRef(null);
  const profileData = useContextSelector(AuthContext, (ctx) => ctx.profileData);
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
    control,
    reset,
  } = useForm({});
  const handle = (e) => {
    if (showPassword.includes(e)) {
      setShowPassword((prev) => {
        return prev?.filter((res) => {
          return res != e;
        });
      });
    } else {
      setShowPassword([...showPassword, e]);
    }
  };
  const onSubmit = async (body) => {
    setLoader(true);
    let hostname = window.location.hostname;
    hostname = hostname.replace(/^www\./, "");
    hostname = hostname.replace(/^ag\./, "");
    try {
      const { status, data: response_users } = await apiPost(
        apiPath.affiliate,
        {
          whatsappNumber: body?.mobile,
          username: body?.username,
          password: body?.password,
          confirmPassword: body?.confirmPassword,
          website: hostname || "SABAEXCH",
        }
      );
      if (status === 200) {
        if (response_users.success) {
          toast.success(response_users?.message);
          setLoader(false);
          reset();
          setShow(false);
        } else {
          toast.error(response_users?.message);
          setLoader(false);
        }
      } else {
        toast.error(response_users?.message);
        setLoader(false);
      }
    } catch (err) {
      setLoader(false);
    }
  };
  return (
    <div id="js_profile_from" className="info-model setting-item">
      <Form onSubmit={handleSubmit(onSubmit)} className="info-model-left">
        <div
          className="caption-text border-blue"
          translate="label_setting_data"
        >
          Affiliate
        </div>
        <div className="wrap">
          <div className="form-group" id="WITHDRAWER_NAME">
            <label className="form-label colon" translate="label_payee_name">
              Username
            </label>
            <div className="input-case fr payeeName-input">
              <input
                className="input-control fr"
                type="text"
                {...register("username", {
                  required: {
                    value: true,
                    message: "Please enter username",
                  },
                })}
                placeholder="Username"
              />{" "}
              {errors.username && errors.username.message && (
                <div class="error-tips">{errors.username.message}</div>
              )}
            </div>
          </div>{" "}
          <div className="form-group" id="WITHDRAWER_NAME">
            <label className="form-label colon" translate="label_payee_name">
              Password
            </label>
            <div className="input-case fr payeeName-input">
              <input
                type={showPassword.includes("new") ? "text" : "password"}
                className="input-control fr"
                placeholder="Please enter password"
                maxLength={12}
                minLength={6}
                {...register("password", {
                  required: "Please enter password",
                  validate: (value) => {
                    if (value === "") {
                      return true;
                    }
                    if (!!value.trim()) {
                      return true;
                    } else {
                      return "White space are not allowed";
                    }
                  },
                })}
              />{" "}
              {errors.password && errors.password.message && (
                <div class="error-tips">{errors.password.message}</div>
              )}
            </div>
          </div>{" "}
          <div className="form-group" id="WITHDRAWER_NAME">
            <label className="form-label colon" translate="label_payee_name">
              Confirm Password
            </label>
            <div className="input-case fr payeeName-input">
              <input
                type={showPassword.includes("confirmNew") ? "text" : "password"}
                className="input-control fr"
                placeholder="Please enter confirm password"
                maxLength={12}
                minLength={6}
                onInput={(e) => preventMaxInput(e)}
                {...register("confirmPassword", {
                  required: {
                    value: true,
                    message: "Please enter confirm password",
                  },
                  validate: (value) => {
                    if (value === "") {
                      return true;
                    }
                    if (!isEmpty(watch("password"))) {
                      if (value == watch("password")) {
                        return true;
                      } else {
                        return "password and confirm password does not match.";
                      }
                    }
                  },
                })}
                onChange={(e) => {
                  setValue("confirmPassword", e.target.value, {
                    shouldValidate: true,
                  });
                }}
              />{" "}
              {errors.confirmPassword && errors.confirmPassword.message && (
                <div class="error-tips">{errors.confirmPassword.message}</div>
              )}
            </div>
          </div>{" "}
          <div className="form-group" id="WITHDRAWER_NAME">
            <label className="form-label colon" translate="label_payee_name">
              Mobile
            </label>
           
              <Controller
                control={control}
                name="mobile"
                rules={{
                  required: "Please enter mobile number",
                  validate: (value) => {
                    let inputValue = value
                      ?.toString()
                      ?.slice(
                        inputRef?.current?.state?.selectedCountry?.countryCode
                          ?.length,
                        value?.length
                      );
                    if (inputValue?.length < 10) {
                      return t("MobileMin");
                    } else if (inputValue?.length > 12) {
                      return t("MobileMax");
                    } else {
                      return true;
                    }
                  },
                }}
                render={({ field: { ref, ...field } }) => (
                  <>
                    <PhoneInput
                      {...field}
                      inputExtraProps={{
                        ref,
                        required: true,
                        autoFocus: true,
                      }}
                      ref={inputRef}
                      className="inputrefNew"
                      placeholder="Mobile Number"
                      country={"bd"}
                      disableDropdown={true}
                      countryCodeEditable={false}
                    />
                  </>
                )}
              />
              {errors.mobile && errors.mobile.message && (
                <div class="error-tips">{errors.mobile.message}</div>
              )}
          
          </div>{" "}
        </div>
        <div className="setting-item-footer">
          <button
            type="submit"
            className="button btn-submit"
            translate="button_submit"
          >
            Submit
          </button>
        </div>
      </Form>
    </div>
  );
};

export default Affiliate;
